module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "c01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Maps#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb",
    staticStyle: {
      "margin-top": "0em"
    },
    attrs: {
      "id": "c01sec1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Maps#ch01sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mediterranean on the Eve of the Crusades")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb",
    attrs: {
      "id": "c01sec2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Maps#ch01sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outremer: Crusader territory in the Holy Land")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "c01sec3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Maps#ch01sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crusader Jerusalem")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "ded1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062059772_Prologue#ch02"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "p01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062059772_Part_1#pa01"
    }
  }, [_vm._v("Part I: "), _c('i', [_vm._v("The Middle East before the Crusades")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_1#ch03"
    }
  }, [_vm._v("1    The Christian World")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_2#ch04"
    }
  }, [_vm._v("2    The Arab Conquests")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_3#ch05"
    }
  }, [_vm._v("3    Palestine under the Umayyads and the Arab Tribes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c06"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_4#ch06"
    }
  }, [_vm._v("4    The Abbasids and the Arab Eclipse")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_5#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5    Byzantine Crusades")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_6#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6    Muslim Wars and the Destruction of Palestine")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "p02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Part_2#pa02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: "), _c('i', [_vm._v("The Turkish Invasion and the First Crusade")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_7#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7    The Turkish Invasion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_8#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8    The Call")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_9#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9    The First Crusade")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "p03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Part_3#pa03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: "), _c('i', [_vm._v("The Founding of the Templars and the Crusader States")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_10#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10   The Origins of the Templars")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_11#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11   Outremer")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_12#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12   Zengi’s Jihad")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_13#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13   The Second Crusade")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "p04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Part_4#pa04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV: "), _c('i', [_vm._v("The Templars and the Defence of Outremer")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_14#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14   The View from the Temple Mount")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_15#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15   The Defence of Outremer")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_16#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16   Templar Wealth")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "p05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Part_5#pa05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part V: "), _c('i', [_vm._v("Saladin and the Templars")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_17#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17   Tolerance and Intolerance")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_18#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18   Saladin’s Jihad")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_19#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19   The Fall of Jerusalem to Saladin")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "p06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Part_6#pa06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part VI: "), _c('i', [_vm._v("The Kingdom of Acre")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_20#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20   Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_21#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21   The Mamelukes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_22#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22   The Fall of Acre")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "p07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Part_7#pa07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part VII: "), _c('i', [_vm._v("Aftermath")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_23#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23   Lost Souls")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_24#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24   The Trial")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "c27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Chapter_25#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25   The Destruction of the Templars")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "c28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Photo_Section#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Section")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "c29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Bibliography#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "c30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Notes#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "c31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Index#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "atas"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#ratas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "bac"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Back_ad#rbac",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back Ad")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "also"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Also_by#also1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Michael Haag")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "cred"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Credits#rcred",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "cop"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062059772_Copyright#cop1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rbackmatter01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df79f2b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062059772_Contents.vue
// module id = 69
// module chunks = 0